export function getApiBaseUrl() {
  const configuredBaseUrl = (process.env.REACT_APP_API_BASE_URL || '').trim();

  if (configuredBaseUrl) {
    return configuredBaseUrl.replace(/\/$/, '');
  }

  if (typeof window === 'undefined') {
    return 'http://localhost:8000/api';
  }

  const { hostname, origin } = window.location;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:8000/api';
  }

  return `${origin}/api`;
}

export function getApiRoot(apiBaseUrl = getApiBaseUrl()) {
  return String(apiBaseUrl).replace(/\/api\/?$/, '');
}

export function resolveMediaUrl(value, apiBaseUrl = getApiBaseUrl()) {
  if (!value) {
    return '';
  }

  if (/^(https?:)?\/\//i.test(value) || value.startsWith('data:') || value.startsWith('blob:')) {
    return value;
  }

  if (String(value).startsWith('/static/')) {
    return value;
  }

  const apiRoot = getApiRoot(apiBaseUrl);
  let path = String(value).trim();

  if (!path) {
    return '';
  }

  if (path.startsWith('public/')) {
    path = path.slice('public/'.length);
  }

  if (path.startsWith('/storage/')) {
    path = `/media/${path.slice('/storage/'.length)}`;
  } else if (path.startsWith('storage/')) {
    path = `/media/${path.slice('storage/'.length)}`;
  } else if (path.startsWith('media/')) {
    path = `/${path}`;
  } else if (!path.startsWith('/media/') && !path.startsWith('/')) {
    path = `/media/${path}`;
  }

  try {
    return new URL(path, `${apiRoot}/`).toString();
  } catch {
    return path;
  }
}